<template>
  <button
    class="bg-[var(--green100)] px-4 py-2 text-white w-full rounded-md"
    @click="showDrawer"
  >
  {{ title }}
   
  </button>
</template>

<script>
export default {
    name:"Drawer Buttons",
    props:["title"]
};
</script>

<style>
</style>